function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import ServiceFactory from "../../service";

/*
 * Enrich Contact — provider lookup + AI consistency review (PlunkDocs
 * specs/mockups/contact-management-additions.html §1).
 *
 *   POST /v1/person/enrich/{id}         → {personId, providers, method,
 *        identityScore, fields:[{field,current,found,provider,verdict,
 *        reason,applyable}]}   verdict ∈ MATCH | NEW | CONFLICT
 *   POST /v1/person/enrich/{id}/apply   → {applied, skipped}
 *        body {emails[], phones[], firstName, lastName, ageRange, gender}
 *
 * Nothing is ever applied automatically. MATCH + NEW are pre-checked,
 * CONFLICT never. identityScore < 60 collapses the panel to "probably not
 * the same person" with everything unchecked. The per-field provider is for
 * audit only — deliberately NOT shown in the UI (spec). Address rows can't
 * be applied yet (the apply endpoint has no address field) — shown
 * check-disabled.
 */

const FIELD_LABELS = {
  firstName: "First name",
  lastName: "Last name",
  email: "Email",
  phone: "Phone",
  ageRange: "Age range",
  address: "Address",
  gender: "Gender"
};
const VERDICT_STYLE = {
  MATCH: {
    background: "#e7f6ec",
    color: "#1d7a3e"
  },
  NEW: {
    background: "#e8f0fe",
    color: "#1a56c4"
  },
  CONFLICT: {
    background: "#fff3e0",
    color: "#b25e09"
  }
};
const LOW_SCORE = 60;
function personSvc(api) {
  const Service = ServiceFactory.getType(api, "audience"); // /v1 root
  return new Service();
}
export default class EnrichModal extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "toggle", i => this.setState({
      checked: {
        ...this.state.checked,
        [i]: !this.state.checked[i]
      }
    }));
    _defineProperty(this, "apply", async () => {
      const {
        result,
        checked
      } = this.state;
      const body = {
        emails: [],
        phones: []
      };
      (result.fields || []).forEach((f, i) => {
        if (!checked[i]) return;
        if (f.field === "email") body.emails.push(f.found);else if (f.field === "phone") body.phones.push(f.found);else if (f.field === "firstName") body.firstName = f.found;else if (f.field === "lastName") body.lastName = f.found;else if (f.field === "ageRange") body.ageRange = f.found;else if (f.field === "gender") body.gender = f.found;
      });
      this.setState({
        phase: "applying",
        error: ""
      });
      try {
        const r = await personSvc(`/person/enrich/${this.props.personId}/apply`).postAsync(body);
        if (!this._alive) return;
        const t = document.querySelector("paper-toast");
        const n = r && r.applied && r.applied.length || 0;
        if (t) t.show(n ? `Applied ${n} field${n === 1 ? "" : "s"} from enrichment.` : "Nothing new to apply — the selected values were already on the contact.");
        this.props.onApplied();
      } catch (err) {
        if (this._alive) this.setState({
          phase: "review",
          error: err.message || "Apply failed."
        });
      }
    });
    this.state = {
      phase: "running",
      // running | review | applying | error
      result: null,
      checked: {},
      // row index -> bool
      expanded: false,
      // low-score override
      error: ""
    };
    this._alive = true;
  }
  componentDidMount() {
    this._alive = true;
    this.run();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  async run() {
    try {
      const r = await personSvc(`/person/enrich/${this.props.personId}`).postAsync({});
      if (!this._alive) return;
      const lowScore = r.identityScore != null && Number(r.identityScore) < LOW_SCORE;
      const checked = {};
      (r.fields || []).forEach((f, i) => {
        const applyable = f.applyable !== false && f.field !== "address";
        // MATCH + NEW pre-checked, CONFLICT never; nothing pre-checked
        // when the identity match is doubtful.
        checked[i] = applyable && !lowScore && (f.verdict === "MATCH" || f.verdict === "NEW");
      });
      this.setState({
        phase: "review",
        result: r,
        checked
      });
    } catch (err) {
      if (this._alive) this.setState({
        phase: "error",
        error: err.message || "Enrichment failed."
      });
    }
  }
  selectedCount() {
    return Object.values(this.state.checked).filter(Boolean).length;
  }
  render() {
    const {
      phase,
      result,
      checked,
      expanded,
      error
    } = this.state;
    const overlay = {
      position: "fixed",
      inset: 0,
      background: "rgba(15,23,35,.45)",
      zIndex: 1000,
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "center",
      overflowY: "auto",
      padding: "48px 16px"
    };
    const box = {
      background: "#fff",
      borderRadius: "10px",
      width: "640px",
      maxWidth: "100%",
      padding: "22px 24px",
      boxShadow: "0 12px 40px rgba(0,0,0,.25)"
    };
    const busy = phase === "running" || phase === "applying";
    const lowScore = result && result.identityScore != null && Number(result.identityScore) < LOW_SCORE;
    const showTable = phase !== "running" && result && (result.fields || []).length > 0 && (!lowScore || expanded);
    return /*#__PURE__*/React.createElement("div", {
      style: overlay,
      onClick: e => {
        if (e.target === e.currentTarget && !busy) this.props.onClose();
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: box
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "10px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "heading-label",
      style: {
        fontSize: "17px"
      }
    }, "Enrichment review \u2014 ", this.props.contactName || "Contact"), /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        cursor: "pointer",
        color: "#9aa4b2"
      },
      onClick: () => !busy && this.props.onClose()
    }, "close")), phase === "running" && /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "12px 0"
      }
    }, "Looking this contact up with our data partners and running the AI consistency review \u2014 usually 10\u201330 seconds\u2026"), phase === "error" && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      style: {
        color: "#c0392b",
        fontSize: "13px"
      }
    }, error), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "flex-end"
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: this.props.onClose
    }, "Close"))), phase !== "running" && phase !== "error" && result && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        flexWrap: "wrap",
        marginBottom: "10px"
      }
    }, result.identityScore != null && /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: "12px",
        fontWeight: 700,
        borderRadius: "12px",
        padding: "3px 10px",
        ...(lowScore ? VERDICT_STYLE.CONFLICT : VERDICT_STYLE.MATCH)
      }
    }, "identity match ", Math.round(Number(result.identityScore)), "%"), /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, result.method === "ai" ? "AI-reviewed — verdicts + rationale per field" : "Rule-based comparison (AI unavailable)")), (result.fields || []).length === 0 && /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "Our data partners had no additional records for this contact."), lowScore && !expanded && (result.fields || []).length > 0 && /*#__PURE__*/React.createElement("div", {
      style: {
        background: "#fff3e0",
        border: "1px solid #f5c98a",
        borderRadius: "8px",
        padding: "12px 14px",
        marginBottom: "10px"
      }
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        fontSize: "13px",
        margin: 0
      }
    }, "The found record is ", /*#__PURE__*/React.createElement("b", null, "probably not the same person"), " (identity match below ", LOW_SCORE, "%). Nothing is selected."), /*#__PURE__*/React.createElement("a", {
      style: {
        fontSize: "12px",
        cursor: "pointer"
      },
      onClick: () => this.setState({
        expanded: true
      })
    }, "Show the found fields anyway")), showTable && /*#__PURE__*/React.createElement("table", {
      className: "territory-table",
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      style: {
        width: "30px"
      }
    }), /*#__PURE__*/React.createElement("th", null, "Field"), /*#__PURE__*/React.createElement("th", null, "Current"), /*#__PURE__*/React.createElement("th", null, "Found"), /*#__PURE__*/React.createElement("th", null, "Verdict"))), /*#__PURE__*/React.createElement("tbody", null, (result.fields || []).map((f, i) => {
      const applyable = f.applyable !== false && f.field !== "address";
      return /*#__PURE__*/React.createElement("tr", {
        key: i
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: !!checked[i],
        disabled: !applyable || busy,
        title: applyable ? "" : "Not applyable yet",
        onChange: () => this.toggle(i)
      })), /*#__PURE__*/React.createElement("td", null, FIELD_LABELS[f.field] || f.field), /*#__PURE__*/React.createElement("td", {
        style: {
          color: f.current ? undefined : "#9aa4b2"
        }
      }, f.current || "—"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("b", null, f.found)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: "11px",
          fontWeight: 700,
          borderRadius: "10px",
          padding: "2px 8px",
          ...(VERDICT_STYLE[f.verdict] || {})
        },
        title: f.reason || ""
      }, f.verdict), f.reason && /*#__PURE__*/React.createElement("div", {
        className: "territory-hint",
        style: {
          margin: "2px 0 0",
          fontSize: "11px"
        }
      }, f.reason)));
    }))), error && /*#__PURE__*/React.createElement("p", {
      style: {
        color: "#c0392b",
        fontSize: "12px",
        margin: "8px 0 0"
      }
    }, error), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "14px"
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, this.selectedCount(), " selected \xB7 nothing is applied until you confirm"), /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        gap: "8px"
      }
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: this.props.onClose
    }, "Discard"), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      disabled: busy || this.selectedCount() === 0,
      onClick: this.apply
    }, phase === "applying" ? "Applying…" : `Apply ${this.selectedCount() || ""}`))))));
  }
}